import { render, staticRenderFns } from "./error-report.vue?vue&type=template&id=308cacbc&scoped=true&"
import script from "./error-report.vue?vue&type=script&lang=js&"
export * from "./error-report.vue?vue&type=script&lang=js&"
import style0 from "./error-report.vue?vue&type=style&index=0&id=308cacbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308cacbc",
  null
  
)

export default component.exports